import { useCallback } from 'react';
import { StyledRecentAndFavoriteListItem } from '../styles';
import { AssistantSearchListItemProps } from '../hooks/useAssistantSearchResultListMap';

interface ListItemProps {
    assistantSearchListItemProps: AssistantSearchListItemProps;
    handleClick: (searchTerm: string) => void;
    focused: boolean;
    recentAndFavoriteMergedListLength: number;
}

export const AssistantRecentAndFavoriteListItem = ({
    assistantSearchListItemProps,
    handleClick,
    focused,
}: ListItemProps) => {
    const { itemId, value, rightItem, ...props } = assistantSearchListItemProps;

    const handleOnClick = useCallback(() => {
        handleClick(value ?? '');
    }, [handleClick, value]);

    return (
        <StyledRecentAndFavoriteListItem
            id={itemId}
            key={itemId}
            tabIndex={0}
            focused={focused}
            shouldScrollIntoView={focused}
            onClick={(e) => {
                handleOnClick();
                e.stopPropagation();
                e.preventDefault();
            }}
            rightItem={rightItem}
            {...props}
        />
    );
};
